import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <div>
      <Header />
      <div className=" mt-[30px]">{children}</div>
      <Footer classes="bg-[#7B3BCC] pb-10 pt-[20px] mt-[60px]" />
    </div>
  );
};

export default Layout;
